export const FUEL_INCLUSION_ADDON__UNITS = 'km';
export const FUEL_INCLUSION_ADDON__BRIEF =
  'Avoid the hassle of refueling and just enjoy the drive.';
export const FUEL_INCLUSION_ADDON__DESCRIPTION = 'No refueling required! Just enjoy your drive.';
export const ADDON_NAME__MAXIMUM_PROTECTION = 'Maximum protection';
export const ADDON_NAME__PREMIUM_PROTECTION = 'Premium protection';
export const ADDON_NAME__MILEAGE_PACKAGE = 'Mileage package';
